import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=5b0e0f7c&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=5b0e0f7c&prod&lang=less&scoped=true"
import style1 from "./Table.vue?vue&type=style&index=1&id=5b0e0f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e0f7c",
  null
  
)

export default component.exports